<template>
  <div>
    <div class="back-title title-bar">
      <i class="el-icon-back c-pointer mr-r4" @click="clickBackButton" style="cursor:pointer"></i> 비밀번호 초기화
    </div>
    <div class="text-regular">
      해당 계정의 비밀번호를 초기화 하고 등록된 E-Mail로 통지합니다.
    </div>
    <el-form :model="passwordObject" label-position="top" :rules="rules" ref="passwordForm">
      <el-form-item label="관리자 비밀번호 입력" prop="adminPassword">
        <el-input type="password" v-model="passwordObject.adminPassword" placeholder="입력해 주세요."></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button size="large" @click="clickBackButton">취소</el-button>
      <el-button size="large" type="primary" @click="clickInitPasswordButton">초기화</el-button>
    </el-row>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import UserSettingAPI from '@/api/settings/user/user-setting';
import rsaEncrypt from '@/utils/rsa-encrypt';

export default {
  name: 'WInitPassword',
  props: {
    selectedUserInfo: Object,
  },
  data() {
    return {
      passwordObject: {
        adminPassword: null,
      },
      rules: {
        adminPassword: {
          required: true,
          validator: this.validatePassword,
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    clickBackButton() {
      this.$emit('click-back-button');
    },
    clickInitPasswordButton() {
      this.$refs.passwordForm.validate().then(() => {
        const fieldData = {
          password: this.passwordObject.adminPassword,
        };

        rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
          const params = {
            managerId: this.selectedUserInfo.managerId,
            managerName: this.selectedUserInfo.managerName,
            email: this.selectedUserInfo.email,
            password: encryData.password,
          };
          UserSettingAPI.initPassword(params).then((response) => {
            const result = response.data.data;
            if (!isNil(result)) {
              if (isEqual(result, 'SUCCESS')) {
                this.$message(msgUtil.getCustomMsgData('메일을 발송하였습니다.'));
                this.clickBackButton();
              } else if (isEqual(result, 'NO_EMAIL')) {
                this.$message(msgUtil.getCustomMsgData('이메일 정보가 없습니다.'));
              } else {
                this.$message(msgUtil.getCustomMsgData('메일 전송을 실패하였습니다.'));
              }
            }
          });
        });
      }).catch(() => {});
    },
    validatePassword(rule, value, callback) {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        const fieldData = {
          password: this.passwordObject.adminPassword,
        };
        rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
          UserSettingAPI.checkAdminPassword({
            password: encryData.password,
          }).then((response) => {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('관리자 비밀번호가 맞지 않습니다.'));
            }
          });
        });
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/InitPassword.vue